<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
  <path fill-rule="evenodd" d="M14.204 12 8 5.795l1.591-1.59L17.387 12 9.59 19.796 8 18.204 14.204 12Z" clip-rule="evenodd"/>
</svg>
